import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { formatMoney } from 'accounting-js';
import Monogram from '../product-details-monogrammable';
import Checkbox from '../../atoms/checkbox';
import { useProduct } from '../../utils/context/product-provider';

const Monogrammable = styled(Monogram)`
  margin-bottom: 2rem;
`;

const MonogramCheckbox = styled(Checkbox)`
  margin-bottom: 2rem;
`;

const MonogramForm = (props) => {
  const {
    state: {
      addMonogram
    },
    handleMonogramClick
  } = useProduct();

  return (
    <>
      {props.variant.prices[0].monogram.monogrammable_only ? (
        <Monogrammable
          variant={props.variant.id}
          colors={
            props.variant.prices[0].monogram.monogram_customizations.colors
          }
          fonts={props.variant.prices[0].monogram.monogram_customizations.fonts}
          maxTextLength={
            props.variant.prices[0].monogram.monogram_max_text_length
          }
        />
      ) : (
        <>
          <MonogramCheckbox
            id="pdp-monogram"
            name="pdp-monogram"
            value={addMonogram}
            active={addMonogram}
            changed={() => {
              handleMonogramClick(addMonogram);
              props.setMonogramSelected(!addMonogram);
            }}
          >
            {`Add monogram +${formatMoney(
              props.variant.prices[0].monogram.monogram_price
            )}`}
          </MonogramCheckbox>
          {addMonogram && (
            <Monogrammable
              variant={props.variant.id}
              colors={
                props.variant.prices[0].monogram.monogram_customizations.colors
              }
              fonts={
                props.variant.prices[0].monogram.monogram_customizations.fonts
              }
              maxTextLength={
                props.variant.prices[0].monogram.monogram_max_text_length
              }
            />
          )}
        </>
      )}
    </>
  );
};

MonogramForm.defaultProps = {
  variant: null
};

MonogramForm.propTypes = {
  setMonogramSelected: PropTypes.func.isRequired,
  variant: PropTypes.object
};

export default MonogramForm;
